import { mergeCatalogue, type Catalogue } from "./define.js";
import { common } from "./common.js";
import { layout } from "./layout.js";
import { auth } from "./auth.js";
import { lists } from "./lists.js";
import { wishes } from "./wishes.js";
import { places } from "./places.js";
import { welcome } from "./welcome.js";
import { chat } from "./chat.js";
import { calendar } from "./calendar.js";
import { search } from "./search.js";
import { activity } from "./activity.js";
import { settings } from "./settings.js";
import { encryption } from "./encryption.js";
import { share } from "./share.js";
import { tags } from "./tags.js";
import { attachments } from "./attachments.js";
import { pwa } from "./pwa.js";
import { notify } from "./notify.js";

/**
 * Every message in the app, in both languages.
 *
 * One namespace per screen or subsystem, each in its own file, merged here. The
 * merge refuses duplicates rather than letting one namespace shadow another —
 * see `define.ts` for why the two languages sit on the same line.
 */
const parts = [
  common,
  layout,
  auth,
  lists,
  wishes,
  places,
  welcome,
  chat,
  calendar,
  search,
  activity,
  settings,
  encryption,
  share,
  tags,
  attachments,
  pwa,
  notify,
];

export const catalogue: Catalogue = mergeCatalogue(parts as Catalogue[]);

/** The union of every key, so `t()` is checked at compile time. */
export type MessageKey = keyof (typeof common &
  typeof layout &
  typeof auth &
  typeof lists &
  typeof wishes &
  typeof places &
  typeof welcome &
  typeof chat &
  typeof calendar &
  typeof search &
  typeof activity &
  typeof settings &
  typeof encryption &
  typeof share &
  typeof tags &
  typeof attachments &
  typeof pwa &
  typeof notify);
